export default __webpack_public_path__ + "media/images/dog-smiling-b213151c4d64fc04ef3641c8001f99a4.png";